import { Grid } from "@material-ui/core";
import React from "react";

const ErrorBoundryRender = ({ error, resetErrorBoundary }) => {
  return (
    <Grid
      style={{ height: "100vh", width: "100%", backgroundColor: "white" }}
    ></Grid>
  );
};

export default ErrorBoundryRender;
